import { Button } from '@/components/ui/button'
import { IconButton } from '@/components/ui/icon-button'
import * as Popover from '@/components/ui/popover'
import { Text } from '@/components/ui/text'
import { Loading } from '@components'
import { A } from '@solidjs/router'
import dayjs from 'dayjs'
import { AtSign, MoveDownRight } from 'lucide-solid'
import { For, Show, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { useMessageMention } from '../../../../state/mentions/useMentions'
import { useUi } from '../../state'

export default function () {
  const [loadingDeletion, setLoadingDeletion] = createSignal<string>()
  const { channelPathRoot, channelMessageMentions } = useService(useUi)()
  const { setDeleteMessageMention, deleteMessageMentionResource } =
    useService(useMessageMention)()

  const handleClearNotifications = (id: string) => {
    setDeleteMessageMention(id)
    setLoadingDeletion(id)
  }

  const d = () => deleteMessageMentionResource.loading && loadingDeletion()

  return (
    <Popover.Root
      positioning={{
        placement: 'bottom-start',
      }}
    >
      <Popover.Trigger
        asChild={(triggerProps) => (
          <Show when={channelMessageMentions()?.length}>
            <Button
              {...triggerProps()}
              colorPalette="bg"
              size="xs"
              variant="solid"
            >
              <AtSign />
              Notifications
            </Button>
          </Show>
        )}
      />
      <Popover.Positioner>
        <Popover.Content minW="300px">
          <Popover.Arrow>
            <Popover.ArrowTip />
          </Popover.Arrow>
          <Grid
            gap={3}
            p={3}
            maxHeight="500px"
            overflow="auto"
          >
            <For each={channelMessageMentions()}>
              {(notification) => (
                <Grid
                  gridTemplateColumns="1fr auto"
                  alignItems="center"
                >
                  <Grid gap={0}>
                    <Text>Mention</Text>
                    <Text textStyle="xs">
                      {dayjs(notification.created_at).format('DD MMMM, YYYY - HH:mm')}
                    </Text>
                  </Grid>
                  <A href={`${channelPathRoot()}/message/${notification.message_id}`}>
                    <Show
                      when={!(d() === notification.id)}
                      fallback={<Loading />}
                    >
                      <IconButton
                        size='xs'
                        onClick={() => handleClearNotifications(notification.id)}
                        colorPalette="tscGreen"
                        variant="subtle"
                      >
                        <MoveDownRight />
                      </IconButton>
                    </Show>
                  </A>
                </Grid>
              )}
            </For>
          </Grid>
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  )
}
